import { KatLitFilteredElement, register } from '../../shared/base';
import { KatHero } from '.';

/**
 * @component {kat-hero-list-actions} KatHeroListActions Component used display hero list actions.
 */
@register(KatHero.slotMapping.listActions.name)
export class KatHeroListActions extends KatLitFilteredElement {
  constructor() {
    super(
      KatHero.slotMapping.listActions.name,
      KatHero.slotMapping.listActions.allowed
    );
  }
}
